import styled from 'styled-components/macro';

import { hexToRGB } from '@repo-level/core-front';

export interface ScPromoPanelsProps {
  isMobile?: boolean;
}

export const ScPromoPanels = styled.div<ScPromoPanelsProps>`
  display: grid;
  gap: 8px;

  .divider {
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.1)};
    margin: 16px 0;
  }
`;
